import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { VisitorParkingApiPricingEntry } from '@/models'

export interface GetVisitorParkingSettingsRequest {
  buildingId: number
}

export interface GetVisitorParkingSettingsResponse {
  buildingId: number
  pricing: Array<VisitorParkingApiPricingEntry>
}

export const getVisitorParkingSettingsQueryKey = (data: GetVisitorParkingSettingsRequest) => [
  'useGetVisitorParkingSettings',
  data.buildingId,
]

export const getVisitorParkingSettings = async ({
  buildingId,
}: GetVisitorParkingSettingsRequest) => {
  const response = await authAPI.get<GetVisitorParkingSettingsResponse>(
    `/visitor-parking/settings`,
    { params: { buildingId } },
  )
  return response.data
}

export const useGetVisitorParkingSettings = (data: GetVisitorParkingSettingsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: () => getVisitorParkingSettings(data),
    queryKey: getVisitorParkingSettingsQueryKey(data),
    retry: false,
  })
}
